module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage Record")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, _vm._l((_vm.records), function(record) {
    return _c('li', [_c('div', {
      staticClass: "article"
    }, [_c('p', {
      staticClass: "text_article"
    }, [_vm._v(_vm._s(record.pick) + "    "), _c('b', [_vm._v(_vm._s(record.result))])]), _vm._v(" "), _c('b', [_vm._v(_vm._s(record.date))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(record)
        }
      }
    }, [_vm._v("Delete")]), _vm._v("\n             \n          "), _c('a', {
      attrs: {
        "href": "javascript;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'W')
        }
      }
    }, [_vm._v("Win")]), _vm._v("\n             \n          "), _c('a', {
      attrs: {
        "href": "javascript;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'L')
        }
      }
    }, [_vm._v("Loss")]), _vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07de3464"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ManageRecord.vue
// module id = 279
// module chunks = 1